module.exports = __webpack_public_path__ + "images/vthumb-mihaela.webp";